import { YouTubeVideoId } from '@customer/config/videos';
import PaywallPage from '@customer/templates/paywall-page/PaywallPage';
import { useTranslation } from 'react-i18next';

export function HealthPaywall() {
  const { t } = useTranslation();

  return (
    <PaywallPage
      title={t('HealthPaywallTitle')}
      subtitle={t('HealthPaywallSubtitle')}
      description={t('HealthPaywallDescription')}
      videoProps={{
        videoId: YouTubeVideoId.FleetHealth,
        title: t('HealthPaywallVideoTitle'),
      }}
    />
  );
}

export default HealthPaywall;
